class AuthService {
    static instance;
  
    static getInstance() {
      if (!AuthService.instance) {
        AuthService.instance = new AuthService();
      }
      return AuthService.instance;
    }
  
    setLogoutCallback(logoutFn) {
      this.logoutCallback = logoutFn;
    }
  
    async logout() {
      if (this.logoutCallback) {
        await this.logoutCallback();
      }
    }
  }
  
export const authService = AuthService.getInstance();